function selectPack(element, quantity) {
  try {
    // Remove active class from all options
    document.querySelectorAll('.pack-option').forEach(option => {
      option.classList.remove('active');
    });
    
    // Add active class to selected option
    element.classList.add('active');
    
    // Update hidden quantity input
    const hiddenQtyInput = document.getElementById('product-qty');
    if (hiddenQtyInput) {
      hiddenQtyInput.value = quantity;
    }
    
    // Try different selectors for the quantity input
    const quantitySelectors = [
      '.quantity-selector__input',
      'input[name="quantity"]',
      '.quantity__input'
    ];
    
    let quantityInput = null;
    for (const selector of quantitySelectors) {
      const input = document.querySelector(selector);
      if (input) {
        quantityInput = input;
        break;
      }
    }

    if (quantityInput) {
      quantityInput.value = quantity;
      // Create and dispatch both input and change events
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    
    // Change subscription frequency based on pack selection
    if (typeof changeSubscriptionFrequency === 'function') {
      changeSubscriptionFrequency(quantity);
    }
  } catch (error) {
    // Error handling
  }
}

// Function to change subscription frequency based on pack selection
function changeSubscriptionFrequency(packNumber) {
  try {
    const rechargeWidget = document.querySelector('recharge-subscription-widget');
    if (!rechargeWidget || !rechargeWidget.shadowRoot) {
      return;
    }

    const shadowRoot = rechargeWidget.shadowRoot;
    const sellingPlansElement = shadowRoot.querySelector('rc-selling-plans');
    
    if (!sellingPlansElement || !sellingPlansElement.shadowRoot) {
      return;
    }

    const sellingPlansShadow = sellingPlansElement.shadowRoot;
    
    // Map pack number to option index (1->0, 2->1, 3->2)
    const optionIndex = packNumber - 1;
    
    // Try to find and change dropdown select
    const dropdown = sellingPlansShadow.querySelector('select, .rc-plans-select');
    if (dropdown && dropdown.tagName === 'SELECT') {
      if (dropdown.options[optionIndex]) {
        dropdown.selectedIndex = optionIndex;
        dropdown.value = dropdown.options[optionIndex].value;
        
        // Dispatch events to notify the widget of the change
        dropdown.dispatchEvent(new Event('change', { bubbles: true }));
        dropdown.dispatchEvent(new Event('input', { bubbles: true }));
      }
      return;
    }
    
    // Try to find and click button-style selectors
    const buttons = sellingPlansShadow.querySelectorAll('.rc-plans-button, button[type="button"]');
    if (buttons.length > 0) {
      if (buttons[optionIndex]) {
        buttons[optionIndex].click();
      }
      return;
    }
    
    // Try to find radio buttons
    const radioButtons = sellingPlansShadow.querySelectorAll('input[type="radio"]');
    if (radioButtons.length > 0) {
      if (radioButtons[optionIndex]) {
        radioButtons[optionIndex].checked = true;
        radioButtons[optionIndex].dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
    
  } catch (error) {
    // Error handling
  }
}


